import Button from '__core/modules/atoms/Button';
import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';

export default function EditorialAccessErrorScreen({ onRetry }) {
  const { t } = useTranslation(['digitalPrograms', 'users']);
  const errorRef = React.useRef(null);

  // El árbol anterior se desmonta, así que el foco caería en <body> y el aviso no se anunciaría.
  React.useEffect(() => {
    errorRef.current?.focus();
  }, []);

  return (
    <main className="error-boundary-page">
      <div>
        <div role="alert">
          <h1 className="text-title-strong" ref={errorRef} tabIndex={-1}>
            {t('digitalPrograms:access_unavailable')}
          </h1>
        </div>

        <Button onClick={onRetry} text={t('users:editorial_access_retry')} variant="inline" />
      </div>
    </main>
  );
}

EditorialAccessErrorScreen.propTypes = { onRetry: PropTypes.func.isRequired };
